import React, { useState } from "react";
import axios from "axios";
import { formatPhoneNumber } from "../utils/formatPhoneNumber";
import { CONTACT_BASE_URL } from "../services/contactService";
import "./ContactStyle.css";

const ContactMe = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      // For phone field, store the raw digits in state
      const digits = value.replace(/[^\d]/g, "");
      setFormData({
        ...formData,
        [name]: digits,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    // Clear any error for this field
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }
  };

  //hide email
  const [showFullEmail, setShowFullEmail] = useState(false);
  const fullEmail = "osman.techy@gmail.com";
  const maskedEmail = "(osman)***@gmail.com";

  const handleClick = () => {
    setShowFullEmail(!showFullEmail);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    setIsSubmitted(false);

    // Validate required fields
    const { firstName, lastName, email, phone, subject, description } =
      formData;
    const newErrors = {};

    if (!firstName) newErrors.firstName = "First name is required.";
    if (!lastName) newErrors.lastName = "Last name is required.";
    if (!email) newErrors.email = "Email address is required.";
    if (!phone) newErrors.phone = "Phone number is required.";
    if (!subject) newErrors.subject = "Subject is required.";
    if (!description) newErrors.description = "Message body is required.";

    if (Object.keys(newErrors).length > 0) {
      setErrors({
        message: "Please fill in all required fields!",
        ...newErrors,
      });
      setLoading(false);
      return;
    }

    // Add this console log right before the axios call to see what's being sent
    console.log("Sending form data:", formData);

    try {
      console.log("Sending form data:", formData);
      // Temporarily use the test endpoint that bypasses validation
      const response = await axios.post(
        `${CONTACT_BASE_URL}/api/contacts/create`,
        formData
      );

      if (response.status === 200 || response.status === 201) {
        setIsSubmitted(true);
        setFormData({
          firstName: "",
          lastName: "",
          phone: "",
          subject: "",
          email: "",
          description: "",
        });
      }
    } catch (error) {
      console.error("Submission error:", error);

      // Add more detailed error logging
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);

        const { message, errors: backendErrors } = error.response.data;

        if (backendErrors && Array.isArray(backendErrors)) {
          console.log("Backend validation errors:", backendErrors);

          // Create a more detailed error object
          const formattedErrors = backendErrors.reduce((acc, err) => {
            acc[err.param] = `${err.msg} (Received: ${err.value})`;
            return acc;
          }, {});

          setErrors({
            message: message || "Validation errors occurred",
            ...formattedErrors,
          });
        } else if (message) {
          setErrors({ message });
        }
      } else if (error.request) {
        setErrors({
          message: "No response from server. Please try again later.",
        });
      } else {
        setErrors({
          message: "An unexpected error occurred. Please try again.",
        });
      }

      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page-modern">
      {/* Header Section */}
      <div className="contact-header">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h1 className="contact-title">Get In Touch</h1>
              <p className="contact-subtitle">
                Have questions or want to work together? I'd love to hear from
                you!
              </p>
            </div>
          </div>
        </div>
      </div>


      {/* Main Contact Section */}
      <div className="contact-container">
        <div className="container">
          <div className="row">
            {/* Contact Info */}
            <div className="col-lg-4 mb-4 mb-lg-0">
              <div className="contact-info-card">
                <h3>Contact Information</h3>
                <p className="contact-intro">
                  Feel free to reach out using any of the methods below. I'll
                  get back to you as soon as possible.
                </p>

                <div className="contact-method">
                  <div className="contact-icon">
                    <i className="fa fa-envelope"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Email</h4>
                    <a
                      href="mailto:osman.techy@gmail.com"
                      onClick={handleClick}
                      className="contact-link text-muted"
                    >
                      {showFullEmail ? fullEmail : maskedEmail}
                    </a>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">
                    <i className="fa fa-map-marker"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Location</h4>
                    <p>Minneapolis, Minnesota</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">
                    <i className="fa fa-clock-o"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Availability</h4>
                    <p>Monday - Friday, 9AM - 5PM CST</p>
                  </div>
                </div>

                <div className="social-links">
                  <h4>Connect With Me</h4>
                  <div className="social-icons">
                    <a
                      href="https://www.linkedin.com/in/mahmoudaosman/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-icon"
                    >
                      <i className="fa fa-linkedin"></i>
                    </a>
                    <a
                      href="https://github.com/mahmoudahmadosman"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-icon"
                    >
                      <i className="fa fa-github"></i>
                    </a>
                    <a
                      href="https://www.facebook.com/moudeyahmad"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-icon"
                    >
                      <i className="fa fa-facebook-f"></i>
                    </a>
                    <a
                      href="https://twitter.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-icon"
                    >
                      <i className="fa fa-twitter"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-8">
              <div className="contact-form-card">
                {isSubmitted ? (
                  <div className="success-message text-center">
                    <div className="success-icon mb-2">
                      <i className="fa fa-check-circle fa-3x text-success"></i>
                    </div>
                    <div classname="text-muted">
                      {" "}
                      <h5>Thank You!</h5>
                      <span>
                        Your message has been sent successfully. I'll get back
                        to you soon.
                      </span>
                    </div>

                    <button
                      className="btn btn-primary mt-3"
                      onClick={() => setIsSubmitted(false)}
                    >
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <>
                    <h2 className="form-title text-uppercase">
                      Let's get in touch!
                    </h2>

                    {errors.message && (
                      <div className="alert alert-danger">
                        <i className="fa fa-exclamation-circle me-2"></i>
                        {errors.message}
                      </div>
                    )}

                    <form onSubmit={handleSubmit} className="contact-form">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <div className="form-group">
                            <label htmlFor="firstName">
                              First Name <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="fa fa-user"></i>
                              </span>
                              <input
                                type="text"
                                className={`form-control ${
                                  errors.firstName ? "is-invalid" : ""
                                }`}
                                id="firstName"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                placeholder="Enter your first name"
                              />
                            </div>
                            {errors.firstName && (
                              <div className="invalid-feedback d-block">
                                {errors.firstName}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <div className="form-group">
                            <label htmlFor="lastName">
                              Last Name <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="fa fa-user"></i>
                              </span>
                              <input
                                type="text"
                                className={`form-control ${
                                  errors.lastName ? "is-invalid" : ""
                                }`}
                                id="lastName"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                placeholder="Enter your last name"
                              />
                            </div>
                            {errors.lastName && (
                              <div className="invalid-feedback d-block">
                                {errors.lastName}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <div className="form-group">
                            <label htmlFor="email">
                              Email <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="fa fa-envelope"></i>
                              </span>
                              <input
                                type="email"
                                className={`form-control ${
                                  errors.email ? "is-invalid" : ""
                                }`}
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter your email"
                              />
                            </div>
                            {errors.email && (
                              <div className="invalid-feedback d-block">
                                {errors.email}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <div className="form-group">
                            <label htmlFor="phone">
                              Phone Number{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="fa fa-mobile"></i>
                              </span>
                              <input
                                type="tel"
                                className={`form-control ${
                                  errors.phone ? "is-invalid" : ""
                                }`}
                                id="phone"
                                name="phone"
                                value={formatPhoneNumber(formData.phone)}
                                onChange={handleChange}
                                placeholder="(•••) •••-••••"
                                maxLength={14}
                              />
                              {errors.phone && (
                                <div className="invalid-feedback d-block">
                                  {errors.phone}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 mb-3">
                          <div className="form-group">
                            <label htmlFor="subject">
                              Subject <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="fa fa-tag"></i>
                              </span>
                              <select
                                className={`form-select ${
                                  errors.subject ? "is-invalid" : ""
                                }`}
                                id="subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                              >
                                <option value="" disabled>
                                  Select a subject
                                </option>
                                <option value="General Inquiry">
                                  General Inquiry
                                </option>
                                <option value="Project Proposal">
                                  Project Proposal
                                </option>
                                <option value="Job Opportunity">
                                  Job Opportunity
                                </option>
                                <option value="Feedback">Feedback</option>
                                <option value="Other">Other</option>
                              </select>
                              {errors.subject && (
                                <div className="invalid-feedback d-block">
                                  {errors.subject}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 mb-3">
                          <div className="form-group">
                            <label htmlFor="description">
                              Message <span className="text-danger">*</span>
                            </label>
                            <textarea
                              className={`form-control ${
                                errors.description ? "is-invalid" : ""
                              }`}
                              id="description"
                              name="description"
                              value={formData.description}
                              onChange={handleChange}
                              placeholder="Type your message here..."
                              rows={5}
                            ></textarea>
                            {errors.description && (
                              <div className="invalid-feedback d-block">
                                {errors.description}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-12">
                          <button
                            type="submit"
                            className="btn btn-primary submit-btn"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Sending...
                              </>
                            ) : (
                              <>
                                <i className="fa fa-paper-plane me-2"></i>
                                Send Message
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactMe;
